import { getDictionary } from '@synisys/dictionary';
import { parseInt } from 'lodash-es';
import { assertQuarter } from '../shared/date-types';
import { getMonthNames } from '../shared/display';
/**
 * converts date to {year}/{quarter} format
 * @param year year e.g. 1984
 * @param quarter quarter indexed, Q1 -> 1, Q2 -> 2, ...
 */
export function quarterDateToKey(year, quarter) {
    return `${year}/${quarter}`;
}
/**
 * inverse of dateToKey
 * @param key should be in {year}/{quarter} format
 */
export function quarterKeyToDate(key) {
    const [year, quarter] = key.split('/');
    const yearParsed = parseInt(year);
    const quarterParsed = assertQuarter(parseInt(quarter));
    return [yearParsed, quarterParsed];
}
/**
 * this method is called with JS months
 * @param month is JS month which can have values [0 - 11]
 *  */
export function getQuarterFromJsMonth(month) {
    if (month < 0 || 12 <= month) {
        console.error('month value is wrong:', month);
    }
    return (Math.floor(month / 3) + 1);
}
export function getMonthsOfQuarter(quarter, locale = 'en', format = 'short') {
    const start = (quarter - 1) * 3;
    return getMonthNames(locale, format)
        .slice(start, start + 3)
        .join(', ');
}
export function displayQuarterDate(date, translate) {
    const [year, quarter] = date;
    const quarterLabel = translate
        ? translate('sds.quarter')
        : getDictionary().translate('sds.quarter');
    return `${quarterLabel}${quarter} ${year.toString()} (${getMonthsOfQuarter(quarter)})`;
}
